import { useRef, useMemo } from 'react'
import { useIntersectionObserver } from 'usehooks-ts'
import css from 'classnames'

export const usePaginationTrigger = (dependencies: boolean[] = []) => {
  const tableBottom = useRef<HTMLDivElement>(null)
  const entry = useIntersectionObserver(tableBottom, {})

  const isVisible = useMemo(
    () => !!entry?.isIntersecting,
    [entry?.isIntersecting],
  )

  const anchor = useMemo(
    () => (
      <div
        ref={tableBottom}
        className={css({
          hidden: dependencies.some(Boolean),
        })}
      />
    ),
    [dependencies],
  )

  return {
    isVisible,
    anchor,
    ref: tableBottom,
    entry,
  }
}
